module.exports = __webpack_public_path__ + "static/media/lionel_messi.0a28cdc1.jpg";